module.exports = __webpack_public_path__ + "pc/img/PC_top_1224x362.c17cd663.png";